import { render, staticRenderFns } from "./ledScreen.vue?vue&type=template&id=c155e4d4&scoped=true"
import script from "./ledScreen.vue?vue&type=script&lang=js"
export * from "./ledScreen.vue?vue&type=script&lang=js"
import style0 from "./ledScreen.vue?vue&type=style&index=0&id=c155e4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c155e4d4",
  null
  
)

export default component.exports